export const styles = {
    backgrounds: [
        { className: "primary-bg-colour", colour: "#B3F50D" },
        { className: "secondary-bg-colour", colour: "#191919" },
        { className: "tertiary-bg-colour", colour: "#EFEFEF" },
        { className: "inactive-bg-colour", colour: "#cccccc" },
        { className: "misc-bg-colour", colour: "#f0f0f0" },
        { className: "notification-badge-bg", colour: "#2E7D32" },
    ],
    text: [
        { className: "primary-text", colour: "#ffffff" },
        { className: "secondary-text", colour: "#191919" },
        { className: "tertiary-text", colour: "#666666" },
        { className: "misc-text", colour: "#2E7D32" },
    ],
    // force primary-text to black on primary-bg-colour only :(
    contextualText: [
        { parentClassName: "primary-bg-colour", className: "primary-text", colour: "#000000", fontWeight: "700" },
    ],
    borders: [
        { className: "primary-border-colour", colour: "#2E7D32" },
        { className: "secondary-border-colour", colour: "#191919" },
        { className: "primary-free-border-colour", colour: "#666666" },
    ],
};
